"use client"

import type { Media } from "#models/media"

import React, { useEffect, useRef } from "react"
//@ts-ignore currently no types available
import { swiffyslider } from "swiffy-slider"

import { swiffysliderextensions } from "#modules/product/imageSlider/swiffySliderExtension.min"
import SvgArrowDown from "#svgs/semantic icons/ArrowDown"

import "swiffy-slider/css"

import { twMerge } from "#lib/twMergeConfig"
import { SelfGrowingImage } from "#modules/optimization/media/image"
import { AutomaticVideo } from "#modules/optimization/media/video"

// TODO split into client & server component - rendered media as children into client component
export function ImageSlider({ images }: { images: Media[] }) {
  const sliderRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    //@ts-ignore currently no types available
    if (!window.swiffyslider) {
      //@ts-ignore currently no types available
      window.swiffyslider = swiffyslider
      //@ts-ignore currently no types available
      window.swiffyslider.extensions = swiffysliderextensions
    }

    if (!sliderRef.current) return

    //@ts-ignore currently no types available
    window.swiffyslider.initSlider(sliderRef.current)
    //@ts-ignore currently no types available
    window.swiffyslider.extensions.initSlider(sliderRef.current)
  }, [sliderRef.current])

  if (images.length === 1) {
    // @ts-ignore
    return <MediaWrapper media={images[0]} priority={true} className={"my-12"} />
  }

  // All the margin and padding classes etc are for the drop shadow to not be cut off
  return (
    <div ref={sliderRef} className="swiffy-slider slider-nav-dark slider-nav-outside slider-nav-touch slider-nav-visible slider-nav-mousedrag ![--swiffy-slider-item-gap:95px]">
      <ul className="slider-container hide-scrollbar !-mx-11 !w-auto !px-11 !py-12 sm:!mx-0 sm:!px-14 md:!mx-4">
        {images.map((image, index) => (
          <li key={index} className={"flex items-center"}>
            <MediaWrapper media={image} priority={index === 0} />
          </li>
        ))}
      </ul>

      <NavigationControls sliderRef={sliderRef} />
    </div>
  )
}

function MediaWrapper({ media, priority, className }: { media: Media; priority: boolean; className?: string }) {
  if (media.mime.startsWith("video")) {
    return (
      // TODO poster url for video, so the first frame isnt empty while downloading
      // TODO video controls?
      <AutomaticVideo
        media={media}
        lazy={true}
        className={twMerge("h-auto max-h-[280px] w-full object-contain drop-shadow-[0_3px_21px_rgba(0,0,0,0.3)] sm:max-h-[450px] md:max-h-[500px]", className)}
      />
    )
  }

  return (
    // Ohne w-fit funktioniert das laden und sizen der bilder in safari nicht - in anderen browsern wird w-fit nicht benötigt...
    <div className={twMerge("mx-auto flex h-[280px] w-fit flex-col justify-center sm:h-[450px] md:h-[500px]", className)}>
      <SelfGrowingImage media={media} className={"max-h-full drop-shadow-[0_3px_21px_rgba(0,0,0,0.3)]"} sizes="80vw" placeholder={"blur"} priority={priority} lazy={!priority} />
    </div>
  )
}

function NavigationControls({ sliderRef }: { sliderRef: React.RefObject<HTMLDivElement> }) {
  return (
    <>
      <div className={"slider-custom-nav absolute -left-9 bottom-0 top-0 flex items-center text-black md:left-0"}>
        <SvgArrowDown
          className={"size-6 rotate-90 cursor-pointer transition-colors hover:text-gold-130 md:size-8"}
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            //@ts-ignore currently no types available
            window.swiffyslider.slide(sliderRef.current, false)
          }}
        />
      </div>

      <div className={"slider-custom-nav absolute bottom-0 left-[calc(100%+12px)] top-0 flex items-center text-black md:left-[unset] md:right-0"}>
        <SvgArrowDown
          className={"size-6 -rotate-90 cursor-pointer select-none transition-colors hover:text-gold-130 md:size-8"}
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            //@ts-ignore currently no types available
            window.swiffyslider.slide(sliderRef.current, true)
          }}
        />
      </div>
    </>
  )
}
